/**
 * Created by yz on 2017/3/27.
 */
{
    angular.module('interfaceModule')
        .controller('UserController',UserController);
    UserController.$inject = ['$scope',"requestHandler",'utils.constant','md5','ModalWindow','alertControl','$state'];
    function UserController($scope,requestHandler,constant,md5,ModalWindow,alertControl,$state) {
        let vm=this;
        let collect={
            Change:Change,
            // changPage:false,
            preservation:preservation,
            // changPassword:changPassword,
            getUserInfo:getUserInfo,
            Recharge:Recharge,
            gotoRecharge:gotoRecharge,
            'userId':'',
            'phone':'',
            'email':'',
            'userName':'',
            'pwd':'',
            'accountbalance':'0',
            'qrpayModal':null,
            'manager':true,   //管理员
            'refreshBalance':refreshBalance ,//余额刷新
            'gotoRechargeRecord' : gotoRechargeRecord,
            'checkRechargeTransid':checkRechargeTransid,   //检测充值单号


        };
        vm.collect=collect;
         active();

         function active() {
             //新加的：
             // $scope.$on("$destroy", function(e) {
             //     console.log('$on');
             //     if(collect.qrpayModal){
             //         console.log('collect.qrpayModal');
             //         collect.qrpayModal.close();
             //     }
             //
             // })


             //获取当前登录的用户ID
             requestHandler.simpleRequest(constant.action.getUserId).then(function (respone) {
                 collect.userId=respone.data[0].loginuserid;
                 console.log(collect.userId);
                 collect.userName=collect.userId;
             }).then(function () {
                 collect.getUserInfo();
             });



         }

         function gotoRecharge(){
             $state.go('main.recharge',{'userId':collect.userId});
         }

        //是否弹出修改密码窗口
        function Change() {
            // vm.collect.changPage=! vm.collect.changPage;
            $scope.userId=collect.userId;
            ModalWindow.open({
                'templateUrl':'app/views/modals/qruserModal.html',
                'controller':'QruserModalController',
                // 'width':320,
                // 'height':360,
                'scope':$scope,
                'windowClass':"qruser_window"
            });
        }

        //弹出选择充值方式和金额窗口
        function Recharge(){
            $scope.userId=collect.userId;
            console.log(collect.userId + '进行充值dddd');
            //在这里改,加一个return
            ModalWindow.open({
                'templateUrl':'app/views/modals/rechargeModal.html',
                'controller':'RechargeModalController',
                // 'width':320,
                // 'height':360,
                'scope':$scope,
                'windowClass':"qruser_window"
            });
        }
        //弹出充值单检测窗口
        function checkRechargeTransid() {
            $scope.userId=collect.userId;
            ModalWindow.open({
                'templateUrl':'app/views/modals/checkRechargeTransidModal.html',
                'controller':'CheckRechargeTransidModalController',
                // 'width':320,
                // 'height':360,
                'scope':$scope,
                'windowClass':"qruser_window"
            });
        }

        //获取个人详细信息
        function getUserInfo() {
            let params=[{
                'userid': collect.userId,
            }];
            let str='userinfo='+JSON.stringify(params);
            requestHandler.simpleRequest(constant.action.getUserInfoById,str).then(function (respone) {
                console.log(respone);   //这里有用户的个人信息，比如是否管理员
                collect.accountbalance = respone.data[0].users.rows[0].userbalance;  //余额
               // collect.manager = respone.data[0].users.rows[0].groupname;
                /*if(respone.data[0].users.rows[0].groupname == '管理员'){
                    collect.manager =true;
                }*/
            });

        }

        //修改个人信息
        function preservation() {

            let params=[{
                'userid': collect.userId,
                // 'phone':collect.phone,
                'username':collect.userName,
                // 'email':collect.email,
                // 'pwd':md5.createHash(encodeURIComponent(collect.password))
            }];
            let str='userinfo='+JSON.stringify(params);
            requestHandler.simpleRequest(constant.action.usersset,str).then(function (respone) {
                console.log(respone);
                if (respone.data[0].result==1){
                    // alert("修改成功")
                    let alert=alertControl.show('',
                        '修改成功',
                        [{
                            'title':'确定',
                            'action':function(){
                                alert.close();
                            }
                        }]
                    );
                }else if (respone.data[0].result==0){
                    // alert("修改失败")
                    let alert=alertControl.show('',
                        '修改失败',
                        [{
                            'title':'确定',
                            'action':function(){
                                alert.close();
                            }
                        }]
                    );
                }
            });
        }

        //账户充值：
        // function Recharge(){
        //     console.log('进行充值');
        // }

        function refreshBalance() {
            let data = [{
                'userid':collect.userId
            }];
            let param = "transaction=" + JSON.stringify(data);
            requestHandler.simpleRequest(constant.action.balancetransactioncheck,param,function(response){
                console.log("刷新余额后：",response);
            }).then(function () {
                getUserInfo();
            });

        }

        //跳到充值记录页面
        function gotoRechargeRecord(){
            $state.go('main.rechargeRecord',{'userId':collect.userId});
        }




    }


}